import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Loader } from 'components';
import TextInput from 'components/Inputs/TextInput/TextInputV2';
import { ReactComponent as LeftIcon } from 'static/icons/left.svg';
import { FIELDS } from './form';
import { useForgotPassword } from './hooks';

import { StyledButton, Header, StyledForm, StyledGumbLogo } from '../styled';

const ForgotPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { register, onSubmit, errors, isLoading } = useForgotPassword();

  // Capture Google Analytics parameters
  const gaParams = useMemo(() => {
    const params = new URLSearchParams();
    for (const [key, value] of searchParams.entries()) {
      if (key.startsWith('_g')) {
        params.append(key, value);
      }
    }
    return params.toString();
  }, [searchParams]);

  const handleBack = () => {
    navigate(`/${gaParams ? `?${gaParams}` : ''}`);
  };

  return (
    <StyledForm onSubmit={onSubmit}>
      <StyledGumbLogo />
      <Header>
        <LeftIcon onClick={handleBack} />
        {t('auth.recovery')}
      </Header>
      <TextInput
        register={register}
        error={errors[FIELDS.EMAIL]}
        name={FIELDS.EMAIL}
        label={t('auth.labels.email')}
      />
      <StyledButton
        variant={isLoading ? 'secondary' : null}
        disabled={isLoading}
      >
        {isLoading ? (
          <Loader type="button" size="28px" thickness={2} />
        ) : (
          t('auth.send')
        )}
      </StyledButton>
    </StyledForm>
  );
};

export default ForgotPage;
